import { CompanyFilter } from "../legacy/types/companyFilter";

export type TamSpendType = "IT" | "AI";

interface TAMConfig {
  spendType?: TamSpendType | null;
  //TODO: remove spendCategoryIds property as not necessary anymore with the inclusion of spendCategoryWeights
  spendCategoryIds: string[];
  spendCategoryWeights: Array<{
    id: string;
    weight: number;
  }>;
}

export interface SAMConfig {
  industry: {
    ids: number[];
    sicIds: string[];
    naicsIds: string[];
    excludedIds: number[];
    excludedSicIds: string[];
    excludedNaicsIds: string[];
  };
  geography: {
    regionsIds: string[];
    countryIds: string[];
    stateIds: string[];
    excludedCountryIds: string[];
  };
}

export interface SOMConfig {
  employeeRange: { min: number | undefined; max: number | undefined };
  revenueRange: { min: number | undefined; max: number | undefined };
  productIds: number[];
  productsInclusionMethod: "ANY_PRESENT" | "ALL_PRESENT";
  excludedProductIds: number[];
  excludedProductsInclusionMethod: "NONE_PRESENT";
}

export interface MatchFileConfig {
  fileId: string;
  fileName: string;
  uploaded: string;
  lastMatched: string | null;
  totalRows: number | null;
  processedRows: number | null;
  matchedRows: number | null;
  invalidRows: number | null;
  salesWins: number | null;
  salesLosses: number | null;
  processedChunks: number | null;
  totalChunks: number | null;
  enableHierarchyClassification?: boolean | null;
}

export interface ICPConfig {
  productIds?: number[];
  customerMatch?: MatchFileConfig;
}

export enum WorkspaceVisibility {
  PRIVATE = "private",
  PUBLIC = "public",
}

export interface WorkspacePermission {
  can_duplicate: boolean;
  can_view: boolean;
  can_write: boolean;
}

export interface Workspace {
  id: string;
  name: string;
  configuration: {
    tam: TAMConfig;
    sam: SAMConfig;
    som: SOMConfig;
    productCategoryIds: string[];
    competitorsProductIds: number[];
    excludedCompetitorsProductIds: number[];
    whitespace: MatchFileConfig | null | undefined;
    icp: ICPConfig | null | undefined;
    localizeInstalls: boolean;
  };
  // come from backend
  filters: CompanyFilter | string;
  userFilters: CompanyFilter | undefined;
  inserted_at: Date;
  updated_at: Date;
  description: string;
  visibility: WorkspaceVisibility;
  owner_email: string;
  permissions: WorkspacePermission;
}

export enum Market {
  TAM = "tam",
  SAM = "sam",
  SOM = "som",
}

export enum ViewOption {
  MARKET_LANDSCAPE = 0,
  COMPETITIVE_ANALYSIS = 1,
  COMPANY_LIST = 2,
}
